var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tabData),function(item,index){return _c('a-button',{key:'btn' + index,class:_vm.currentValue == item.value ? 'active-btn-class btn-class' : 'btn-class',style:(_vm.defaultBtnStyle),attrs:{"round":""},on:{"click":function($event){return _vm.tabClick(item.value)}}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }